import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

interface BlogPost {
  id: number;
  title: string;
  excerpt: string;
  image: string;
  category: string;
  date: string;
  readTime: string;
  author: string;
}

const BlogPage = () => {
  const blogPosts: BlogPost[] = [
    {
      id: 1,
      title: 'روتين العناية بالبشرة الصباحي المثالي',
      excerpt: 'اكتشفي الخطوات الأساسية لروتين عناية صباحي يمنح بشرتك النضارة والإشراق طوال اليوم. نصائح من خبراء Rose Mist للحصول على بشرة صحية ومشرقة.',
      image: 'https://public.readdy.ai/ai/img_res/f184a051673886795201762df9fcd722.jpg',
      category: 'العناية بالبشرة',
      date: '15 يناير 2025',
      readTime: '5 دقائق',
      author: 'سارة أحمد'
    },
    {
      id: 2,
      title: 'أسرار المكياج الطبيعي للإطلالة اليومية',
      excerpt: 'تعلمي كيفية تطبيق مكياج طبيعي يبرز جمالك الطبيعي دون مبالغة. خطوات بسيطة وسريعة لإطلالة راقية ومناسبة لكل يوم.',
      image: 'https://readdy.ai/api/search-image?query=elegant%20woman%20applying%20natural%20makeup%20with%20brush%2C%20soft%20pink%20vanity%20table%2C%20luxury%20beauty%20products%2C%20professional%20makeup%20tutorial%2C%20clean%20minimal%20aesthetic%2C%20natural%20lighting%2C%20feminine%20sophisticated%20style&width=600&height=400&seq=blog2&orientation=landscape',
      category: 'المكياج',
      date: '12 يناير 2025',
      readTime: '7 دقائق',
      author: 'ليلى محمد'
    },
    {
      id: 3,
      title: 'فوائد المكونات الطبيعية في منتجات التجميل',
      excerpt: 'تعرفي على أهم المكونات الطبيعية المستخدمة في منتجات Rose Mist وفوائدها المذهلة لبشرتك. من الورد إلى الزيوت الطبيعية النادرة.',
      image: 'https://readdy.ai/api/search-image?query=natural%20beauty%20ingredients%20rose%20petals%20essential%20oils%20botanical%20extracts%20on%20soft%20pink%20background%2C%20luxury%20skincare%20composition%2C%20professional%20product%20photography%2C%20clean%20minimal%20aesthetic%2C%20elegant%20feminine%20style&width=600&height=400&seq=blog3&orientation=landscape',
      category: 'الجمال الطبيعي',
      date: '10 يناير 2025',
      readTime: '6 دقائق',
      author: 'نور خالد'
    },
    {
      id: 4,
      title: 'كيف تختارين المنتجات المناسبة لنوع بشرتك',
      excerpt: 'دليل شامل لمساعدتك في اختيار المنتجات المثالية حسب نوع بشرتك. نصائح عملية من خبراء العناية بالبشرة في Rose Mist.',
      image: 'https://readdy.ai/api/search-image?query=elegant%20woman%20examining%20skincare%20products%2C%20luxury%20beauty%20consultation%2C%20soft%20pink%20interior%2C%20professional%20lifestyle%20photography%2C%20clean%20minimal%20aesthetic%2C%20natural%20lighting%2C%20feminine%20sophisticated%20style&width=600&height=400&seq=blog4&orientation=landscape',
      category: 'نصائح الخبراء',
      date: '8 يناير 2025',
      readTime: '8 دقائق',
      author: 'سارة أحمد'
    },
    {
      id: 5,
      title: 'روتين العناية بالبشرة الليلي للبشرة المثالية',
      excerpt: 'اكتشفي أهمية روتين العناية الليلي وكيف يساعد بشرتك على التجدد والإصلاح أثناء النوم. خطوات بسيطة لنتائج مذهلة.',
      image: 'https://readdy.ai/api/search-image?query=elegant%20woman%20applying%20night%20cream%20in%20soft%20bedroom%20lighting%2C%20luxury%20skincare%20routine%2C%20peaceful%20evening%20ambiance%2C%20professional%20lifestyle%20photography%2C%20clean%20minimal%20aesthetic%2C%20feminine%20sophisticated%20style&width=600&height=400&seq=blog5&orientation=landscape',
      category: 'العناية بالبشرة',
      date: '5 يناير 2025',
      readTime: '6 دقائق',
      author: 'ليلى محمد'
    },
    {
      id: 6,
      title: 'أحدث صيحات المكياج لربيع 2025',
      excerpt: 'تعرفي على أحدث صيحات المكياج لهذا الموسم وكيفية تطبيقها بأسلوبك الخاص. ألوان وتقنيات عصرية من عالم الجمال.',
      image: 'https://readdy.ai/api/search-image?query=elegant%20makeup%20collection%20spring%20colors%20pink%20coral%20tones%20on%20soft%20pink%20background%2C%20luxury%20cosmetics%20display%2C%20professional%20product%20photography%2C%20clean%20minimal%20aesthetic%2C%20feminine%20sophisticated%20style&width=600&height=400&seq=blog6&orientation=landscape',
      category: 'المكياج',
      date: '3 يناير 2025',
      readTime: '5 دقائق',
      author: 'نور خالد'
    }
  ];

  return (
    <div className="min-h-screen bg-white" dir="rtl">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-16 bg-gradient-to-br from-rose-50 via-pink-50 to-white">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-5xl lg:text-6xl font-bold text-gray-800 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
              مدونة <span className="text-rose-400">Rose Mist</span>
            </h1>
            <p className="text-lg text-gray-600">
              نصائح جمالية، روتينات عناية، وأدلة شاملة من خبراء التجميل
            </p>
          </div>
        </div>
      </section>

      {/* Featured Post */}
      <section className="py-16">
        <div className="container mx-auto px-4 lg:px-8">
          <Link to={`/blog/${blogPosts[0].id}`} className="group">
            <div className="grid lg:grid-cols-2 gap-12 items-center bg-gradient-to-br from-rose-50 to-pink-50 rounded-3xl overflow-hidden p-8 lg:p-12 hover:shadow-xl transition-shadow">
              <div className="relative h-96 rounded-2xl overflow-hidden">
                <img
                  src={blogPosts[0].image}
                  alt={blogPosts[0].title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div>
                <div className="inline-block bg-rose-400 text-white px-4 py-1.5 rounded-full text-xs font-bold mb-4">
                  مقال مميز
                </div>
                <h2 className="text-4xl font-bold text-gray-800 mb-4 group-hover:text-rose-400 transition-colors" style={{ fontFamily: 'Playfair Display, serif' }}>
                  {blogPosts[0].title}
                </h2>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {blogPosts[0].excerpt}
                </p>
                <div className="flex items-center gap-6 text-sm text-gray-500">
                  <span className="flex items-center gap-2">
                    <i className="ri-calendar-line"></i>
                    {blogPosts[0].date}
                  </span>
                  <span className="flex items-center gap-2">
                    <i className="ri-time-line"></i>
                    {blogPosts[0].readTime}
                  </span>
                  <span className="flex items-center gap-2">
                    <i className="ri-user-line"></i>
                    {blogPosts[0].author}
                  </span>
                </div>
              </div>
            </div>
          </Link>
        </div>
      </section>

      {/* Blog Posts Grid */}
      <section className="py-16 bg-gradient-to-br from-white to-rose-50">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogPosts.slice(1).map(post => (
              <Link
                key={post.id}
                to={`/blog/${post.id}`}
                className="group bg-white rounded-3xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300"
              >
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-3 py-1.5 rounded-full text-xs font-bold text-rose-400">
                    {post.category}
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-800 mb-3 group-hover:text-rose-400 transition-colors">
                    {post.title}
                  </h3>
                  <p className="text-gray-600 text-sm mb-4 leading-relaxed line-clamp-3">
                    {post.excerpt}
                  </p>
                  <div className="flex items-center gap-4 text-xs text-gray-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-calendar-line"></i>
                      {post.date}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line"></i>
                      {post.readTime}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter CTA */}
      <section className="py-20">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="bg-gradient-to-br from-rose-400 to-pink-400 rounded-3xl p-12 text-center text-white">
            <h2 className="text-4xl font-bold mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
              اشتركي في نشرتنا البريدية
            </h2>
            <p className="text-lg mb-8 opacity-90">
              احصلي على أحدث النصائح والعروض الحصرية مباشرة في بريدك
            </p>
            <div className="max-w-md mx-auto flex gap-3">
              <input
                type="email"
                placeholder="بريدك الإلكتروني"
                className="flex-1 px-6 py-4 rounded-full text-gray-800 focus:outline-none"
              />
              <button className="bg-white text-rose-400 px-8 py-4 rounded-full font-bold hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer">
                اشتركي الآن
              </button>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default BlogPage;
